import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { CardData } from '../data/CardData';
import SupportCard from './SupportCard';
import SupportCardModel from '../data/SupportCardModel';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
}));

const isAvailable = (card, TFDFilter, GRADFilter, masteryFilter, skillFilter, characterFilter, distributionFilter) => {
    // 感謝祭・GRADの条件に合致しない場合はすぐに return false;
    if (TFDFilter !== 'any' && card.ideaTFD !== TFDFilter) {return false;}
    if (GRADFilter !== 'any' && card.ideaGRAD !== GRADFilter) {return false;}
    // 対象キャラクターに合致しない場合は return false;
    if (characterFilter.length !== 0 && !characterFilter.includes(card.character)) {
        return false;
    }
    // カード登場種別に合致しない場合は return false;
    if (distributionFilter.length !== 0 && !distributionFilter.includes(card.distributionType)) {
        return false;
    }
    
    // マスタリーでフィルタ
    if (masteryFilter === []) {
        // フィルタが空なら全部出す
        return true;
    } else {
        // TODO: ロジックの調整
        const conditionCheck = [];
        for (const condition of masteryFilter) {
            // フィルタとして入ってきた各項目について，カード自身の持つマスタリーがその項目を含むかどうか判定
            const conditionMatch = card.mastery.filter( x => x.includes(condition) );
            conditionCheck.push(conditionMatch.length);
        }
        // フィルタの項目と合致しないものがある→表示しない
        if (conditionCheck.includes(0)) {
            return false;
        }
    }

    // スキルでフィルタ
    if (skillFilter === []) {
        // フィルタがない場合は表示ok
        return true;
    } else {
        // フィルタがある場合は，フィルタの全条件がカードスキルに含まれること
        return skillFilter.every( x => card.skills.includes(x) );
    }
};

export default function CardGrid(props) {
    const classes = useStyles();
    const TFDFilter = props.TFDFilter;
    const GRADFilter = props.GRADFilter;
    const masteryFilter = props.masteryFilter;
    const skillFilter = props.skillFilter;
    const characterFilter = props.characterFilter;
    const distributionFilter = props.distributionFilter;
    const cardState = CardData.map((d) => {
        return new SupportCardModel(d);
    }).filter((d) => isAvailable(d, TFDFilter, GRADFilter, masteryFilter, skillFilter, characterFilter, distributionFilter));

    // カード名だけ入れる
    const [holdCards, setHoldCards] = React.useState([]);
    const onHoldCardChange = (cardName) => {
        if (holdCards.includes(cardName)) {
            // すでにholdされている→解除する
            const newHold = holdCards.filter(d => d !== cardName);
            setHoldCards(newHold);
        } else {
            // 新しく追加する
            setHoldCards([...holdCards, cardName]);
        }
    };
    const holdCardState = CardData.filter(
        d => holdCards.includes(d.cardName)
    ).map(
        d => {return new SupportCardModel(d);}
    );

    const cardToShow = [...holdCardState, ...(cardState.filter(d => !holdCards.includes(d.cardName)))];

    if (cardToShow.length === 0) {
        return (<Typography>表示できるカードがありません。</Typography>);
    };

    return (
        <Grid container className={classes.root} justify="center" spacing={2}>
            {cardToShow.map((value, index) => (
                <Grid key={index} item>
                    <SupportCard card={value} imageOnlyMode={props.imageOnlyMode} textOnlyMode={props.textOnlyMode} onHold={onHoldCardChange} isHold={holdCards.includes(value.cardName)}/>
                </Grid>
            ))}
        </Grid>
    );
}